"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./Details.css");

function Details(props) {
  var className = props.className,
      textAlign = props.textAlign,
      title = props.title,
      description = props.description,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "textAlign", "title", "description"]);
  var classNames = (0, _classnames["default"])(['stx-details', className, {
    'stx-details--left': textAlign === 'left'
  }, {
    'stx-details--center': textAlign === 'center'
  }, {
    'stx-details--right': textAlign === 'right'
  }]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classNames
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-details__title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "stx-details__description"
  }, description));
}

Details.defaultProps = {
  textAlign: 'left'
};
Details.propTypes = {
  className: _propTypes["default"].string,
  description: _propTypes["default"].string,
  title: _propTypes["default"].string,
  textAlign: _propTypes["default"].oneOf(['left', 'center', 'right'])
};
var _default = Details;
exports["default"] = _default;